// Referral attribution for the Security Service Provider application. A visit to
// /apply?ref=CODE stores the code in the browser (first touch wins) so it can
// prefill the optional referral field even if the applicant finishes later.
// First-party only; nothing is sent anywhere until the application is
// submitted with the code in it.

export const REF_CODE_RE = /^[A-HJ-NP-Z2-9]{8}$/;

const KEY = 'guardly_ref_v1';
const MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000; // 90 days

export function loadStoredReferral() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const v = JSON.parse(raw);
    if (!v || !REF_CODE_RE.test(v.code) || Date.now() - v.at > MAX_AGE_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return v.code;
  } catch {
    return null;
  }
}

export function captureReferralFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const raw = (params.get('ref') || '').trim().toUpperCase();
    if (!REF_CODE_RE.test(raw)) return;
    // First touch wins: an already-stored, still-valid code is kept.
    if (loadStoredReferral()) return;
    localStorage.setItem(KEY, JSON.stringify({ code: raw, at: Date.now() }));
  } catch {
    // Storage unavailable (private mode etc.) is fine; manual entry still works.
  }
}
